// extracted by mini-css-extract-plugin
export default {"whatsappButton":"SocialIcons_whatsappButton__L+S2M","instagramButton":"SocialIcons_instagramButton__xLQRx"};